import React from 'react';

const SvgArrowTop = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 10 6" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 4.757L8.694 6l-.65-.625L5 2.485l-3.045 2.89-.65.625L0 4.757l.657-.617 3.037-2.897L5 0l1.306 1.243L9.343 4.14z"
      opacity={0.2}
    />
  </svg>
);

export default SvgArrowTop;
